/* eslint-disable react/display-name */
import RecordLayoutStyle from './style.js';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Table, DatePicker, Space, Tooltip, Button } from 'antd';
import { Link } from 'react-router-dom';
import {
  EyeOutlined,
  DownloadOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import qs from 'qs';
const { RangePicker } = DatePicker;

// style

// service
import { getRecordsGroup, exportRecordsGroup } from '../../services/user';

// components
import CustomBreadcrumb from '../../components/Breadcrumb';

function RecordGroupPage(props) {
  const [listRecord, setListRecord] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const phoneNumber =
    '+' +
    qs
      .parse(props?.location?.search, {
        ignoreQueryPrefix: true,
      })
      .phoneNumber.trim();
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    userId: '',
    fromDate: '',
    toDate: '',
  });

  useEffect(() => {
    const token = localStorage && localStorage.getItem('opentrace_token');
    if (token === null) {
      window.location.replace('/login');
      return;
    }

    setParams({
      ...params,
      fromDate: moment().subtract(1, 'month').unix(),
      toDate: moment().unix(),
      userId: props.match?.params?.userId,
    });
  }, []);

  useEffect(() => {
    if (params.userId) {
      getRecordList(params);
    }
  }, [params]);

  const routes = [
    {
      name: 'User Management',
      link: '/user-management',
    },
    {
      name: phoneNumber,
    },
  ];

  const columns = [
    {
      title: 'Phonenumber',
      dataIndex: 'phonenumber',
      key: 'phonenumber',
      render: (value, record) => (
        <span>{record?.contact?.phoneNumber || '--'}</span>
      ),
    },
    {
      title: 'From',
      dataIndex: 'contactIdValidFrom',
      key: 'contactIdValidFrom',
      render: (value) => (
        <span>
          {value ? moment(value * 1000).format('DD-MM-YYYY HH:mm:ss') : '--'}
        </span>
      ),
    },
    {
      title: 'To',
      dataIndex: 'contactIdValidTo',
      key: 'contactIdValidTo',
      render: (value) => (
        <span>
          {value ? moment(value * 1000).format('DD-MM-YYYY HH:mm:ss') : '--'}
        </span>
      ),
    },
    {
      title: 'Detail',
      dataIndex: 'groupId',
      key: 'groupId',
      align: 'center',
      render: (value, record) => (
        <div>
          <span>
            <Tooltip title="View">
              <Link
                to={
                  '/records/' +
                  value +
                  '?fromDate=' +
                  record.contactIdValidFrom +
                  '&toDate=' +
                  record.contactIdValidTo +
                  '&userId=' +
                  props.match?.params?.userId +
                  '&phoneNumber=' +
                  phoneNumber
                }
              >
                <EyeOutlined
                  className="detail-user-icon"
                  style={{ fontSize: '22px' }}
                />
              </Link>
            </Tooltip>
          </span>
        </div>
      ),
    },
  ];

  async function getRecordList(params) {
    setLoading(true);
    let res = await getRecordsGroup({
      ...params,
    });

    // let convertData = [];

    setListRecord(res);
    setLoading(false);
  }

  function handleChangePageSize(pagination) {
    setParams({
      ...params,
      page: pagination.current,
    });
  }

  function handleChangeDate(dates) {
    setParams({
      ...params,
      fromDate: (dates[0] && moment(dates[0]).unix()) || '',
      toDate: (dates[1] && moment(dates[1]).unix()) || '',
    });
  }

  async function exportRecordList(params) {
    setIsExporting(true);
    let res = await exportRecordsGroup(params);
    window.location.replace(res);
    setIsExporting(false);
  }

  function handleExport() {
    if (params.userId) {
      exportRecordList({
        userId: params.userId,
        fromDate: params.fromDate,
        toDate: params.toDate,
      });
    }
  }

  return (
    <>
      <RecordLayoutStyle>
        <CustomBreadcrumb routes={routes} />
        <div className="cover-header">
          <div className="space-group">
            <Space className="spaceRecordDate">
              <h4>Contact with {phoneNumber}</h4>
            </Space>
            <Space className="spaceRecordDate">
              <RangePicker
                placeholder={[
                  moment().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss'),
                  moment().format('YYYY-MM-DD HH:mm:ss'),
                ]}
                allowClear={false}
                onChange={handleChangeDate}
                showTime
              />
            </Space>
          </div>
          <div className="cover-export">
            <Button
              type="primary"
              icon={isExporting ? <LoadingOutlined /> : <DownloadOutlined />}
              size={'large'}
              onClick={handleExport}
              disabled={isExporting}
            >
              Export
            </Button>
          </div>
        </div>
        <Table
          dataSource={listRecord.docs}
          columns={columns}
          loading={isLoading}
          onChange={handleChangePageSize}
          pagination={{
            pageSize: params && params.limit,
            total: listRecord && listRecord.totalDocs,
            defaultPageSize: params && params.limit,
            defaultCurrent: params && params.page,
          }}
        />
      </RecordLayoutStyle>
    </>
  );
}

RecordGroupPage.propTypes = {
  match: PropTypes.any,
  location: PropTypes.any,
};

export default RecordGroupPage;
